export const enUS = {
	translation: {
		//LOGIN PAGE
		//header
		'login-header': 'Welcome!',
		//login CTA
		'login-cta': 'Sign in to access our platform!',
		//login question
		'login-question': "Don't have an account?",
		//login plans CTA
		'login-plans-cta': 'Click the button below to see our plans:',
		//login button
		'login-button-plans': 'SEE PLANS',
		//login e-mail field
		'login-email': 'e-mail',
		//login e-mail password
		'login-password': 'password',
		//login button access
		'login-button-access': 'SIGN IN',
		//login button forgot password
		'login-button-forgot-password': 'Forgot your password?',

		//GROUPS HEADER
		//group-welcome
		'group-welcome': 'Welcome',
		//group-intro
		'group-intro': 'You are logged in as',
		//group-admin
		'group-admin': 'Administrator!',
		//group-user
		'group-user': 'User!',
		//group-header
		'group-header': 'GROUPS',
		//group-button
		'group-button': 'NEW GROUP',

		//GROUPS LIST
		//group-list-header
		'group-list-header': 'View Groups',
		//group-list-title
		'group-list-intro': 'PROJECTS',
		//group-list-button
		'group-list-button': 'NEW PROJECT',
		//group-searchbar
		'group-searchbar': 'Search here...',
		//group-no-projects
		'group-no-projects': 'This group does not have any projects! 😢 ',

		//GROUPS TABLE ITEMS
		//group-table-title
		'group-table-title': 'TITLE',
		//group-table-description
		'group-table-description': 'DESCRIPTION',
		//group-table-manager
		'group-table-manager': 'MANAGER',
		//group-table-actions
		'group-table-actions': 'ACTIONS',
		//group-table-action-download
		'group-table-action-download': 'Download CSV',
		//group-table-action-duplicate
		'group-table-action-duplicate': 'Duplicate',
		//group-table-action-edit
		'group-table-action-edit': 'Edit',
		//group-table-action-delete
		'group-table-action-delete': 'Delete',
		//group-table-action-answers
		'group-table-action-answers': 'Records',
		//group-table-action-access
		'group-table-action-access': 'Access',

		//DOWNLOAD CSV MODAL
		'initial-date': 'Start Date',
		'final-date': 'Final Date',
		'generate-excel': 'Generate',

		//GROUPS PAGE
		//group-char-min
		'group-char-min': 'The value must contain at least 4 characters.',
		//group-char-max
		'group-char-max': 'The value must contain a maximum of 20 characters.',
		//group-char-required
		'group-char-required':
			'Please fill in the field correctly. The field must have between 4-20 characters.',
		//group-page-view
		'group-page-view': 'View Groups',
		//group-page-header
		'group-page-header': 'GROUP',
		//group-page-title
		'group-page-title': 'TITLE',
		//group-page-manager
		'group-page-manager': 'MANAGER',
		//group-page-button
		'group-page-button': 'SAVE', //create??
		//group-page-edit
		'group-page-edit': 'EDIT GROUP',
		//group-page-edit-title
		'group-page-edit-title': 'Title',
		//group-page-edit-manager
		'group-page-edit-manager': 'Manager',
		'project-edit-toast': 'Project edited successfully!',

		//PROJECTS PAGE
		//projects-page-view
		'projects-page-view': 'VIEW PROJECTS',
		//projects-page-header
		'projects-page-header': 'PROJECT',
		//projects-page-edit
		'projects-page-edit': 'EDIT PROJECT',

		//PROJECTS EDIT PAGE
		//projects-edit-title
		'projects-edit-title': 'Title',
		//projects-edit-description
		'projects-edit-description': 'Description',
		//projects-edit-manager
		'projects-edit-manager': 'Manager',

		//PROJECTS TABLE ITEMS
		//projects-table-title
		'projects-table-title': 'Title',
		//projects-table-description
		'projects-table-description': 'Description',
		//projects-table-placeholder
		'projects-table-placeholder': 'ex: Study project',
		//projects-table-status
		'projects-table-status': 'Status',
		//projects-table-active
		'projects-table-active': 'Active',
		//projects-table-manager
		'projects-table-manager': 'Manager',
		//projects-table-owner-email
		'projects-table-email-placeholder': 'ex: youre-mail@email.com',
		//projects-table-save
		'projects-table-save': 'SAVE',

		//PROJECT FORMS PAGE
		//projects-forms-warning
		'projects-forms-warning': 'This project does not have any records. 😢',
		//projects-forms-text
		'projects-forms-text': 'TEXT',
		//projects-forms-label
		'projects-forms-label': 'LABEL',
		//projects-forms-number
		'projects-forms-number': 'NUMBER',
		//projects-forms-dropdown
		'projects-forms-dropdown': 'DROPDOWN',
		//projects-forms-checkbox
		'projects-forms-checkbox': 'CHECKBOX',
		//projects-forms-radio
		'projects-forms-radio': 'RADIO',
		//projects-forms-counter
		'projects-forms-counter': 'COUNTER',
		//projects-forms-date
		'projects-forms-date': 'DATE/HOUR',
		//projects-forms-image
		'projects-forms-image': 'PHOTO/IMAGE',
		//projects-forms-sort-button
		'projects-forms-sort-button': 'SORT FIELDS',
		//projects-forms-records-button
		'projects-forms-records-button': 'RECORDS',
		//projects-forms-records-title
		'projects-forms-records-title': 'Title',
		//projects-forms-records-description
		'projects-forms-records-description': 'Description',
		//projects-forms-records-type
		'projects-forms-records-type': 'Type',
		//projects-forms-records-manager
		'projects-forms-records-manager': 'Manager',
		//projects-forms-records-order
		'projects-forms-records-order': 'Order',
		//projects-forms-records-actions
		'projects-forms-records-actions': 'Actions',

		//PROJECT-RECORDS-TABLE
		//project-records-saved
		'project-records-saved': 'RECORDS',
		//project-records-responsible
		'project-records-responsible': 'Manager',
		//project-records-latitude
		'project-records-latitude': 'Latitude',
		//project-records-longitude
		'project-records-longitude': 'Longitude',
		//project-records-date
		'project-records-date': 'Date/Hour',
		//project-records-actions
		'project-records-actions': 'Actions',
		//project-records-answers
		'project-records-answers': 'Answers',
		//project-records-error
		'project-records-error': 'There are no records saved. 😢',
		//project-records-answers-title
		'project-records-answers-title': 'ANSWERS',
		'project-records-generate-pdf': 'Generate Pending Report (PDF)',
		'project-records-no-pendencies': 'No pending items to generate report',

		//GENERAL-ERRORS
		//invalid-email
		'invalid-email': 'Invalid e-mail!',
		//empty-field
		'empty-field': 'Please, fill in the field!',
		//forgot-password-warning
		'forgot-password-warning': 'Please, contact your supervisor!',
		//wrong-email-password
		'wrong-email-password': 'Incorrect e-mail and/or password!',

		//GENERAL-INFOS
		//options-field-requisition
		'options-field-requisition': 'Please, fill in the field with at least one option.',
		//options-field-empty
		'options-field-empty': 'Please, insert a value in the Options field.',
		//insert-value-placeholder
		'insert-value-placeholder': 'Insert a value',
		//write-text-placeholder
		'write-text-placeholder': 'Write the text here...',
		//title-placeholder
		'title-placeholder': 'ex: Title',
		//button-project-field-name
		'button-project-field-name': 'Field Name',
		//button-project-field-description
		'button-project-field-description': 'Description',
		//button-project-field-manager
		'button-project-field-manager': 'Manager',
		//button-project-field-options
		'button-project-field-options': 'Options',
		//obligatory-field
		'obligatory-field': 'Obligatory field',
		//go-back-button
		'go-back-button': 'Go Back',
		//loading-warning
		loading: 'Loading...',
		//delete-option-contract
		'delete-option-contract': 'Do you really want to delete',
		//delete-verification-contract
		'delete-verification-contract': 'When confirmed, the group will be deleted.',
		//delete-option-project
		'delete-option-project': 'Do you really want to delete',
		//delete-verification-project
		'delete-verification-project': 'When confirmed, the project will be deleted.',
		//delete-option-field
		'delete-option-field': 'Do you really want to delete the Field?',
		//delete-verification-field
		'delete-verification-field': 'When confirmed, the field "{{fieldRowTitle}}" will be deleted.',
		//delete-option-field-option
		'delete-option-field-option': 'Do you really want to delete the Field Option?',
		//delete-verification-field-option
		'delete-verification-field-option':
			'When confirmed, the option "{{fieldOptionIdToDeleteTitle}}" will be deleted.',
		//field-delete-button
		'field-delete-button': 'DELETE',
		//field-cancel-button
		'field-cancel-button': 'CANCEL',
		//image-button-return
		'image-button-return': 'RETURN',
		//image-button-next
		'image-button-next': 'NEXT',
		//drag-and-drop-alert
		'drag-and-drop-alert': 'Please, select a CSV file.',
		//drag-and-drop-selected
		'drag-and-drop-selected': 'File selected! 🚀',
		//drag-and-drop-manual
		'drag-and-drop-manual': 'Drag and drop a CSV file or click to select one manually.',
		//new-field-title-header
		'new-field-title': 'NEW FIELD',
		//new-field-dropdown-header
		'new-field-dropdown': 'NEW DROPDOWN',
		//new-field-checkbox-header
		'new-field-checkbox': 'NEW CHECKBOX',
		//new-field-radio-header
		'new-field-radio': 'NEW RADIO',
		//new-field-counter-header
		'new-field-counter': 'NEW COUNTER',
		//new-field-image-header
		'new-field-image': 'NEW IMAGE',
		//sort-fields-button
		'sort-fields-button': 'SORT FIELDS',
		//sidebar-group-button
		'sidebar-group-button': 'Groups',
		'sidebar-group-access': 'Access Control',
		'sidebar-manage-users': 'User Management',

		//HEADERS-NEW-FIELDS
		//new-field-title
		'new-field-header': 'NEW FIELD',
		//new-checkbox-header
		'new-checkbox-header': 'NEW CHECKBOX',
		//new-radio-header
		'new-radio-header': 'NEW RADIO',
		//new-dropdown-header
		'new-dropdown-header': 'NEW DROPDOWN',
		//new-counter-header
		'new-counter-header': 'NEW COUNTER',
		//new-image-header
		'new-image-header': 'NEW IMAGE',

		//FIELDS-TEXTS
		//field-name
		'field-name': 'Field Name',
		//field-name-placeholder
		'field-name-placeholder': 'ex: Title',
		//field-description
		'field-description': 'Field Description',
		//field-description-placeholder
		'field-description-placeholder': 'ex: Write the text...',
		//field-manager
		'field-manager': 'Manager',
		//field-option
		'field-option': 'Option',
		//field-option-placeholder
		'field-option-placeholder': 'Insert a value',
		//field-update-button
		'field-update-button': 'UPDATE',
		//field-csv-error
		'field-csv-error': 'ERROR LOADING CSV',
		//csv-limit-field-options
		'csv-limit-field-options': 'Exceeded number of field options - MAX: 50 fields',

		//PROJECT-FIELDS
		//project-fields-title
		'project-fields-title': 'Title',
		//project-fields-description
		'project-fields-description': 'Description',
		//project-fields-type
		'project-fields-type': 'Type',
		//project-fields-manager
		'project-fields-manager': 'Manager',
		//project-fields-order
		'project-fields-order': 'Order',
		//project-fields-actions
		'project-fields-actions': 'Actions',

		//PROJECT-FIELDS-IDS
		//project-fields-id-title
		'project-fields-id-checkbox': 'Checkbox',
		//project-fields-id-text
		'project-fields-id-text': 'Text',
		//project-fields-id-dropdown
		'project-fields-id-dropdown': 'Dropdown',
		//project-fields-id-radio
		'project-fields-id-radio': 'Radio',
		//project-fields-id-image
		'project-fields-id-image': 'Image',
		//project-fields-id-counter
		'project-fields-id-counter': 'Counter',
		//project-fields-id-date
		'project-fields-id-date': 'Date/Hour',
		//project-fields-id-edit
		'project-fields-id-edit': 'Edit',
		//project-fields-id-delete
		'project-fields-id-delete': 'Delete',
		//project-fields-warning
		'project-fields-warning': 'This project does not have any fields. 😢',

		//CounterFieldSchema
		//counter-field-max
		'counter-field-max': 'The value must contain a maximum of 100 characters.',
		//counter-field-min
		'counter-field-min': 'The value must contain at least 4 characters.',
		//counter-field-required
		'counter-field-required':
			'Please fill in the field correctly. The field must have between 4-100 characters.',

		// Only Admin
		'admin-only': 'Exclusive area for administrators!',

		//Dashboard
		'create-chart-modal-title': 'Create Chart',
		'remove-chart-modal-title': 'Remove Chart',
		'remove-chart-modal-subtitle': 'Do you want to remove the selected chart?',
		'dashboard-select-values-instruction': 'To continue, please select the group and the project.',
		'select-group': 'Select the group',
		'select-project': 'Select the project',
		'select-field': 'Select the field',
		'user-log-analysis': 'User Log Analysis',
		'check-answers': 'View answers',
		'view-image': 'View Image',

		// Grid Locale
		'grid-locale-page': 'Page',
		'grid-locale-more': 'More',
		'grid-locale-to': 'to',
		'grid-locale-of': 'of',
		'grid-locale-next': 'Next',
		'grid-locale-last': 'Last',
		'grid-locale-first': 'First',
		'grid-locale-previous': 'Previous',
		'grid-locale-filterOoo': 'Filter...',
		'grid-locale-equals': 'Equals',
		'grid-locale-notEqual': 'Not equal',
		'grid-locale-lessThan': 'Less than',
		'grid-locale-greaterThan': 'Greater than',
		'grid-locale-lessThanOrEqual': 'Less than or equal',
		'grid-locale-greaterThanOrEqual': 'Greater than or equal',
		'grid-locale-inRange': 'In range',
		'grid-locale-contains': 'Contains',
		'grid-locale-notContains': 'Does not contain',
		'grid-locale-startsWith': 'Starts with',
		'grid-locale-endsWith': 'Ends with',
		'grid-locale-dateFormatOoo': 'dd/mm/yyyy',
		'grid-locale-numberFilterOoo': 'Filter by number...',
		'grid-locale-textFilterOoo': 'Filter by text...',
		'grid-locale-applyFilter': 'Apply filter',
		'grid-locale-clearFilter': 'Clear filter',
		'grid-locale-loadingOoo': 'Loading...',
		'grid-locale-noRowsToShow': 'No records found',
		'grid-locale-selectAll': 'Select all',
		'grid-locale-searchOoo': 'Search...',
		'grid-locale-blanks': 'Blanks',
		'grid-locale-group': 'Group',
		'grid-locale-columns': 'Columns',
		'grid-locale-filters': 'Filters',
		'grid-locale-rowGroupColumnsEmptyMessage': 'Drag columns here to group',
		'grid-locale-valueColumnsEmptyMessage': 'Drag columns here to aggregate',
		'grid-locale-pinColumn': 'Pin column',
		'grid-locale-autosizeThiscolumn': 'Autosize this column',
		'grid-locale-autosizeAllColumns': 'Autosize all columns',
		'grid-locale-resetColumns': 'Reset columns',
		'grid-locale-expandAll': 'Expand all',
		'grid-locale-collapseAll': 'Collapse all',

		// Access Control
		'select-user': 'Select the user',
		'click-select-user': 'Click below to list users',
		'not-found-user': 'User not found',
		'org-without-groups': 'An organization without any groups created!',
		'org-without-projects': 'An group without any projects created!',

		// Generic Error
		'generic-error': 'An error occurred...',

		// Manage
		'user-created': 'User created successfully!',
		'user-deleted': 'User deleted successfully!',
		'user-edited': 'User edited successfully!',
		'add-user': 'Add User',
		'col-name': 'Name',
		'col-email': 'E-mail',
		'col-role': 'Role',
		'col-created-at': 'Created At',
		'col-actions': 'Actions',
		'row-admin-role': 'Administrator',
		'row-user-role': 'User',
		'insert-value': 'Enter the value...',
		'modal-password': 'Password',
		'modal-new-user': 'New User',
		'modal-edit-user': 'Edit User',
		'modal-delete-user': 'Delete User',
		'modal-delete-info': 'Do you really want to delete the user?',
		'modal-reset-password-info':
			"If you do not wish to change the user's password, leave the field blank.",
		'modal-reset-password-label': 'Reset Password',
		'modal-reset-password-warning':
			'When resetting the user\'s password, the default password will be "Handler@1234".',
		'validation-name-min': 'The name must have at least 2 characters',
		'validation-email-invalid': 'Invalid email address',
		'validation-password-min': 'The password must have at least 6 characters',
		'validation-role-min': 'Please select a valid role',

		// Answer Page
		'request-changes': 'Request Changes',
		'see-pendencies': 'View Pending Items',
		'pendency-description': 'Description of the Pending Item',
		'record-pendency': 'Pending Record Item',
		'project-with-no-records': 'This project has no records. 😢',

		// Pendency Card
		'pendency-card-description': 'Description',
		'pendency-card-status': 'Status',
		'pendency-card-owner': 'Requester',
		'pendency-card-created-at': 'Created Date',
		'pendency-card-updated-at': 'Updated Date',
		'pendency-resolved': 'Resolved',
		'pendency-unresolved': 'Unresolved',
		'corrección de pendencia': 'Correction',
		'see-correction': 'View correction',
		'edit-pendency': 'Edit pending',
		'delete-pendency': 'Delete pending item',
		'delete-confirm-description': 'Upon confirmation, the pending item will be deleted.',

		// Correction Page
		'validate-correction': 'Validate Correction',
		'validate-correction-description':
			'Upon confirmation, the correction will be marked as resolved.',
		'correction-created-successfully': 'Correction request created with success!',
		'correction-already-exists': 'A validated answer already exists as a correction.',

		'attachment-image': 'Attach Image',
		'upload-text': 'Click or drag file to this area to upload',
		'upload-hint':
			'Support for a single upload. Strictly prohibited from uploading company data or other banned files.',

		'pendency-report_file': 'pendencies_report_{{recordId}}.pdf'
	}
};
